import React, { useEffect, useMemo } from "react";
import Filter from "./Filter";
import { FormField } from "../data/models";

interface DropdownFieldProps {
  field: FormField;
  value?: number | string; // trenutni ID
  onChange: (nextId: number | string | null) => void; // vrati ID ili null
  disabledOptions?: (number | string)[]; // ID-jevi opcija koje se ne mogu odabrati
  isError?: boolean;
}

export default function DropdownField({
  field,
  value,
  onChange,
  disabledOptions = [],
  isError = false,
}: DropdownFieldProps) {
  const opts = useMemo(() => field.options || [], [field.options]);

  const disabledLabels = useMemo(
    () =>
      opts.filter((o) => disabledOptions.includes(o.id)).map((o) => o.label),
    [opts, disabledOptions]
  );

  const effectiveId = value ?? field.initialValue ?? undefined;

  // Postavi default ID samo ako je polje eksplicitno definiralo initialValue
  useEffect(() => {
    if (value == null && field.initialValue != null) {
      onChange(field.initialValue);
    }
  }, [field.initialValue, value, onChange]);

  // Lista labela
  const labelsList = useMemo(() => opts.map((o) => o.label), [opts]);

  // Trenutno selektirana labela
  const selectedLabel = useMemo(
    () => opts.find((o) => o.id === effectiveId)?.label,
    [opts, effectiveId]
  );

  // Mapiranje natrag iz labela u ID
  const handleFilterChange = (values: string[] | string) => {
    const label = Array.isArray(values) ? values[0] : values;
    const nextId = opts.find((o) => o.label === label)?.id ?? null;
    onChange(nextId);
  };

  return (
    <Filter
      name={field.placeholder}
      data={labelsList}
      selected={selectedLabel ? [selectedLabel] : []}
      onChange={handleFilterChange}
      multiple={false}
      disabledItems={disabledLabels}
      isError={isError}
    />
  );
}
